"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARRAY_QUERY_FORM = exports.withSystemAdminGuard = exports.withAdminGuard = exports.withReadOrSatGuard = exports.withReadGuard = exports.READ_ROLES = exports.TimestampFromString = exports.NonNegativeIntFromString = exports.PositiveIntFromString = exports.TenantIds = exports.oneOrMany = exports.SortDirection = exports.ConnectionStatus = exports.ConsumableName = exports.ConsumableCategory = exports.BusinessUnitCode = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const tags_1 = require("../../../../../utils/tags");
const BusinessUnit = __importStar(require("../../../../business-unit"));
const Device = __importStar(require("../../../../device"));
const common_1 = require("../../../../device/capability/consumable/definition/common");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Common';
/*
 * Vocabulary shared by the legacy v2 Express routes.
 *
 * `unified-api/src/utils/domain.js` derives these literals from the domain at
 * runtime (device model codes, business unit codes, consumable names and
 * categories). The contracts derive them the same way so the enums published
 * in the documents never drift from the domain.
 */
/** `BusinessUnitCode`: the `_tag` of every {@link BusinessUnit.Base.businessUnits} member. */
exports.BusinessUnitCode = effect_1.Schema.Literal(...effect_1.Record.values(BusinessUnit.Base.businessUnits).map(unit => (0, tags_1.getTagLiteral)(unit.fields._tag))).annotations({
    identifier: `${exports.NAMESPACE}.BusinessUnitCode`,
    title: 'Business unit code',
    description: 'Business unit code, as in `device.businessUnit._tag`',
});
/** `ConsumableCategory`: the distinct categories of every consumable definition. */
exports.ConsumableCategory = effect_1.Schema.Literal(...effect_1.Record.values(common_1.Category)).annotations({
    identifier: `${exports.NAMESPACE}.ConsumableCategory`,
    title: 'Consumable category',
});
/** `ConsumableName`: the keys of {@link Device.Capability.Consumable.Definition.Definitions}. */
exports.ConsumableName = effect_1.Schema.Literal(...effect_1.Record.keys(Device.Capability.Consumable.Definition.Definitions)).annotations({
    identifier: `${exports.NAMESPACE}.ConsumableName`,
    title: 'Consumable name',
});
/** `connected` / `disconnected`, mapped onto `status.connection.online`. */
exports.ConnectionStatus = effect_1.Schema.Literal('connected', 'disconnected').annotations({
    identifier: `${exports.NAMESPACE}.ConnectionStatus`,
    title: 'Connection status',
});
exports.SortDirection = effect_1.Schema.Literal('asc', 'desc').annotations({
    identifier: `${exports.NAMESPACE}.SortDirection`,
    title: 'Sort direction',
});
/*
 * Query parameter helpers. Query structs are kept un-identified so Effect
 * emits them as inline parameters; these are building blocks for them.
 */
/** `SingleOrArrayFromQuery`: Express parses one occurrence as a string and several as an array. */
const oneOrMany = (schema) => effect_1.Schema.Union(schema, effect_1.Schema.NonEmptyArray(schema));
exports.oneOrMany = oneOrMany;
/** `TenantIdsFromQuery` */
exports.TenantIds = (0, exports.oneOrMany)(effect_1.Schema.String.pipe(effect_1.Schema.nonEmptyString())).annotations({
    identifier: `${exports.NAMESPACE}.TenantIds`,
    title: 'Tenant ids',
    description: 'Tenant id, or repeated query parameter. Narrowed to the tenants visible to the caller.',
});
exports.PositiveIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive()).annotations({
    identifier: `${exports.NAMESPACE}.PositiveIntFromString`,
    title: 'Positive integer',
});
exports.NonNegativeIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.nonNegative()).annotations({
    identifier: `${exports.NAMESPACE}.NonNegativeIntFromString`,
    title: 'Non-negative integer',
});
/** Epoch milliseconds passed as a query string. */
exports.TimestampFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive()).annotations({
    identifier: `${exports.NAMESPACE}.TimestampFromString`,
    title: 'Timestamp',
    description: 'Unix timestamp in milliseconds',
});
/*
 * Guards. Route guards on legacy v2 routes are shared with v1 and answer v1
 * bodies, so every mirror below is a v1 variant (see `openapi/README.md`).
 */
const Role = User.GlobalUserRole.enums;
/** `routes/v2/api/guards.js` `read`: `RBACRouteGuard` with every back-office and dealer role. */
exports.READ_ROLES = [
    Role.SystemAdmin,
    Role.Admin,
    Role.BrandManager,
    Role.BrandSupportOperator,
    Role.BrandTechOperator,
    Role.Dealer,
    Role.DealerTechnician,
];
/** The `read` guard. */
exports.withReadGuard = openapi_1.Security.v1Roles(...exports.READ_ROLES);
/**
 * `[read, satCredentialRouteGuard]`: `RestApiEndpoint` ORs guard arrays, so a
 * `read` role **or** a fleet SAT (`?sat=`) admits the request. Both security
 * requirements are published; either one satisfies the operation.
 */
const withReadOrSatGuard = (endpoint) => (0, exports.withReadGuard)(endpoint).middleware(openapi_1.Security.V1FleetSat);
exports.withReadOrSatGuard = withReadOrSatGuard;
/** `AdminUserRouteGuard` */
exports.withAdminGuard = openapi_1.Security.v1Roles(...openapi_1.Security.GuardRoles.AdminUser);
/** `SysAdminUserRouteGuard` */
exports.withSystemAdminGuard = openapi_1.Security.v1Roles(...openapi_1.Security.GuardRoles.SystemAdmin);
/**
 * How an array query parameter must be sent to Express. The controllers
 * decode with `S.Array`, and a single bare `key=value` reaches them as a
 * string, so the single-element form needs brackets or repetition.
 */
const ARRAY_QUERY_FORM = (name, first, second) => `Repeat the parameter or use the bracket form (\`${name}[]=${first}&${name}[]=${second}\`); ` +
    `a single bare \`${name}=${first}\` reaches the controller as a string and is rejected.`;
exports.ARRAY_QUERY_FORM = ARRAY_QUERY_FORM;
//# sourceMappingURL=common.js.map